import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "course_container"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "item_img_wrapper" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "item_img_tag"
}
const _hoisted_6 = { class: "tag_text" }
const _hoisted_7 = { class: "item_img_type" }
const _hoisted_8 = { class: "type_text" }
const _hoisted_9 = { class: "item_text" }
const _hoisted_10 = { class: "item_detail" }
const _hoisted_11 = { class: "detail_score" }
const _hoisted_12 = { class: "detail_count" }
const _hoisted_13 = {
  key: 2,
  class: "list1"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "item_img_wrapper" }
const _hoisted_16 = ["src"]
const _hoisted_17 = {
  key: 0,
  class: "item_img_tag"
}
const _hoisted_18 = { class: "tag_text" }
const _hoisted_19 = { class: "item_img_type" }
const _hoisted_20 = { class: "type_text" }
const _hoisted_21 = { class: "item_text_wrapper" }
const _hoisted_22 = { class: "item_text" }
const _hoisted_23 = { class: "item_detail item_detail1" }
const _hoisted_24 = { class: "detail_score" }
const _hoisted_25 = { class: "item_detail" }
const _hoisted_26 = { class: "detail_count" }

import { Tabs, Tab } from 'vant'
import { ref, computed } from 'vue'
import CardTitle from './CardTitle.vue'
import { useThemeColor } from '@/utils/theme'
import { LmsDecorateModule } from '@/api/Models/HomeConfig'
import { useI18n } from 'vue-i18n'
import { useRouter } from 'vue-router'

interface TItem {
  fileId: string
  fileType: number
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Course',
  props: {
    data: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v3d1f1459": (_unref(themeColor))
}))

const props = __props

const router = useRouter()
const skipHandle = (item: TItem) => {
  router.push({
    name: 'courseDetail',
    query: {
      id: item.fileId,
      courseId: '',
      endingType: 0,
      channel: 0,
      courseType: item.fileType > 0 ? 'courseWare' : 'course'
    }
  })
}

const tabIndex = ref(0)
const changeTabIndex = (index: number) => {
  tabIndex.value = index
}

const courseData = computed(() => {
  try {
    // console.log(JSON.parse(props.data.lmsDecorateModuleCategories[tabIndex.value].datas[0].json))
    return JSON.parse(props.data.lmsDecorateModuleCategories[tabIndex.value].datas[0].json)
  } catch (error) {
    return []
  }
})
// 首页课程卡片
const skipSort = computed(() => {
  // 0最新 1最热
  return (
    '/course?sortType=' +
    (props.data.lmsDecorateModuleCategories[0].dataShowRule === 0 ? 1 : 3) +
    '&category=' +
    dataJumpCategoryIds.value
  )
})

const dataJumpCategoryIds = computed(() => {
  try {
    return props.data.lmsDecorateModuleCategories[0].dataJumpCategoryIds[0]
  } catch (error) {
    return ''
  }
})

const type = computed(() => {
  try {
    return JSON.parse(props.data.extendInfo).layoutType
  } catch (error) {
    return 3
  }
})

const isSmallList = computed(() => type.value === 1)
const isBigList = computed(() => type.value === 2)
const isGridList = computed(() => type.value === 3)

const themeColor = useThemeColor()

const tabActive = ref(0)

const { t } = useI18n()
const getFileTypeName = (type: number) => {
  // 类型 0:课程，1:文档，2:视频，3:图片，4:音频，5:交互视频
  switch (type) {
    case 0:
      return t('app_course')
    case 1:
      return t('tag_doc')
    case 2:
      return t('tag_video')
    case 3:
      return t('tag_pic')
    case 4:
      return t('tag_audio')
    case 6:
      return t('superplayer_interactive')
  }
}

return (_ctx: any,_cache: any) => {
  return (courseData.value.length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(CardTitle, {
          title: __props.data.title,
          class: "card_title",
          skipPage: skipSort.value
        }, null, 8, ["title", "skipPage"]),
        (__props.data.code === 'app-category-class')
          ? (_openBlock(), _createBlock(_unref(Tabs), {
              key: 0,
              active: tabActive.value,
              "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((tabActive).value = $event)),
              animated: "",
              "title-inactive-color": "#999999",
              color: _unref(themeColor),
              "line-width": "13px",
              shrink: true,
              onChange: changeTabIndex
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data.lmsDecorateModuleCategories, (item, index) => {
                  return (_openBlock(), _createBlock(_unref(Tab), {
                    key: index,
                    title: item.categoryName
                  }, null, 8, ["title"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["active", "color"]))
          : _createCommentVNode("", true),
        (isBigList.value || isGridList.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["list", { full: isBigList.value }])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseData.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "list_item",
                  key: item.id,
                  onClick: ($event: any) => (skipHandle(item))
                }, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("img", {
                      class: "item_img",
                      src: item.coverImgUrl
                    }, null, 8, _hoisted_4),
                    (item.learnStatus === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('app_learned_short')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(getFileTypeName(item.fileType)), 1)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_9, _toDisplayString(item.fileName), 1),
                  _createElementVNode("p", _hoisted_10, [
                    _createElementVNode("span", _hoisted_11, _toDisplayString(item.score || 0) + _toDisplayString(_ctx.$t('app_score')), 1),
                    _createElementVNode("span", _hoisted_12, " | " + _toDisplayString(item.learnNum) + _toDisplayString(_ctx.$t('app_people_learned')), 1)
                  ])
                ], 8, _hoisted_2))
              }), 128))
            ], 2))
          : _createCommentVNode("", true),
        (isSmallList.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(courseData.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "list_item",
                  key: item.id,
                  onClick: ($event: any) => (skipHandle(item))
                }, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("img", {
                      class: "item_img",
                      src: item.coverImgUrl
                    }, null, 8, _hoisted_16),
                    (item.learnStatus === 1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('app_learned_short')), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("span", _hoisted_20, _toDisplayString(getFileTypeName(item.fileType)), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("p", _hoisted_22, _toDisplayString(item.fileName), 1),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("span", _hoisted_24, _toDisplayString(item.score || 0) + _toDisplayString(_ctx.$t('app_score')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _createElementVNode("span", _hoisted_26, _toDisplayString(item.learnNum) + _toDisplayString(_ctx.$t('app_people_learned')), 1)
                    ])
                  ])
                ], 8, _hoisted_14))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})